import {
	createStyles,
	Divider,
	Flex,
	Group,
	ScrollArea,
	Skeleton,
	Stack,
} from '@mantine/core';
import { AvatarSkeleton } from '@repo/foundations';
import { memo } from 'react';
import { MessageGroupSkeleton } from '../../../features/AiChat/components/MessageGroupSkeleton';

const useStyles = createStyles((theme) => ({
	content: {
		flex: 1,
		overflowY: 'auto',
		padding: theme.spacing.xl,
	},
}));

export const AiChatDrawerSkeleton = memo(() => {
	const { classes } = useStyles();

	return (
		<Stack w="100%" h="100%" px="xl" py="sm">
			<Stack spacing="xs">
				<Group position="apart" mb="md">
					<Group spacing="sm">
						<Skeleton height={20} width={300} radius="md" />
					</Group>
					<Group align="center" spacing="xs">
						<Skeleton height={32} width={80} radius="md" />
						<Skeleton height={32} width={32} radius="md" />
					</Group>
				</Group>
				<Stack spacing="sm">
					<Flex gap="xs">
						<Skeleton height={16} width={128} radius="md" />
						<Group align="center" spacing="xs">
							<AvatarSkeleton size="xxs" />
							<Skeleton height={16} width={120} radius="md" />
						</Group>
					</Flex>
					<Flex gap="xs">
						<Skeleton height={16} width={128} radius="md" />
						<Skeleton height={16} width={30} radius="md" />
					</Flex>
					<Flex gap="xs">
						<Skeleton height={16} width={128} radius="md" />
						<Group spacing="xs">
							<Skeleton height={24} width={24} radius="xs" />
							<Skeleton height={24} width={24} radius="xs" />
							<Skeleton height={24} width={24} radius="xs" />
							<Skeleton height={16} width={60} radius="md" />
						</Group>
					</Flex>
					<Flex gap="xs">
						<Skeleton height={16} width={128} radius="md" />
						<Skeleton height={16} width={40} radius="md" />
					</Flex>
					<Flex gap="xs">
						<Skeleton height={16} width={128} radius="md" />
						<Skeleton height={20} width={60} radius="md" />
					</Flex>
					<Flex gap="xs">
						<Skeleton height={16} width={128} radius="md" />
						<Skeleton height={20} width={50} radius="md" />
					</Flex>
				</Stack>
				<Divider mt="2xl" size="xs" />
			</Stack>
			<ScrollArea className={classes.content}>
				<Stack spacing="5xl">
					<MessageGroupSkeleton />
					<MessageGroupSkeleton />
				</Stack>
			</ScrollArea>
		</Stack>
	);
});
